<div #scrollContaine class="infoForPopUp">
  <div *ngIf="showInformationFields">
    <div class="left">
      <div class="information2 ">
        <span class="div-header" style="font-size: 16px;">Information</span>
        <form [formGroup]="companyInfo">
          <div formGroupName="companyInformation">

            <div class="row" style="padding-top: 10px;">
              <div class="col-md-6" *ngFor="let field of informationFields; let i = index">
                <div class="row align-items-center mb-0 ">
                  <div class="col-md-4">
                    <div class="headings">
                      <p class="text12">{{ field.label }}<span class="text-danger"  *ngIf="field.name !== 'url' && field.name !== 'zipCode' && field.name !== 'address' && field.name !== 'city'
                      && field.name !== 'state' && field.name !== 'country' && field.name !== 'continent' && field.name !== 'employeeCount'">*</span>
                        <span *ngIf="companyInfo.get(field.name)"></span>
                      </p>
                      </div>
                  </div>
                  <div class="col-md-8">
                    <div *ngIf="field.name === 'logo'">
                      <div *ngIf="companyInfo.get('companyInformation.logo')?.value" class="d-flex align-items-center">
                        <img [src]="companyInfo.get('companyInformation.logo')?.value" alt="Logo" width="100"
                          class="me-2" style="margin-bottom: 8px;">
                        <button type="button" class="mwe-button mwe-button--primary"
                          (click)="triggerLogoInputClick()">Update Logo</button>
                        <input type="file" #logoInput (change)="selectFile($event, 'logo')" style="display: none;">
                      </div>
                      <div *ngIf="!companyInfo.get('companyInformation.logo')?.value" class="d-flex align-items-center">
                        <button type="button" class="mwe-button mwe-button--primary"
                          (click)="triggerLogoInputClick()">Add Logo</button>
                        <input type="file" #logoInput (change)="selectFile($event, 'logo')" style="display: none;">
                      </div>
                    </div>

                    <mat-form-field appearance="outline" class="w-100 custome-error-message heading-laptop"
                      *ngIf="field.name !== 'continent' && field.name !== 'country' && field.name !== 'state' && field.name !== 'city' && field.name !== 'logo'"
                      [style.marginBottom]="(companyInfo.get(field.name)?.hasError('required') || companyInfo.get(field.name)?.hasError('pattern')) ? '20px' : '5px'">
                      <span *ngIf="field.name === 'phoneNumber'" matPrefix>&nbsp;&nbsp;{{ companyInfo.get('companyInformation.phoneCode')?.value }}&nbsp;</span>
                      <input matInput [formControlName]="field.name" [placeholder]="'Enter ' + field.label"
                        (input)="(field.name === 'phoneNumber' || field.name === 'year' || field.name === 'zipCode'||field.name === 'employeeCount') ? onInputChangeNumbers($event, field.label) : null"
                        (keypress)="(field.name === 'year' || field.name === 'zipCode'||field.name === 'employeeCount') ? numberOnly($event) : null"
                        [pattern]="( field.name === 'year' || field.name === 'zipCode'|| field.name === 'employeeCount') ? '^[0-9]*$' : ''"
                        [minlength]="(field.name === 'year') ? 4 : (field.name === 'phoneNumber') ? 5 : null"
                        [maxlength]="(field.name === 'year') ? 4 : (field.name === 'phoneNumber') ? 20  : null" [readonly]="field.name === 'email'">
                       
                        <mat-error class="error-message"
                          *ngIf="companyInfo.get('companyInformation.' + field.name)?.hasError('required') && companyInfo.get('companyInformation.' + field.name)?.touched">
                          <img class="error-icon " loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{field.label }} is required
                        </mat-error>
                         
                        <mat-error class="error-message" *ngIf="field.name === 'userName' && companyInfo.get('companyInformation.userName')?.hasError('maxlength')">
                            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                          Limit Exceeded : Max 50 characters
                          </mat-error>
          
                        <mat-error class="error-message"
                          *ngIf="field.name === 'phoneNumber' && companyInfo.get('companyInformation.phoneNumber')?.hasError('pattern')">
                          <img class="error-icon"loading="lazy" alt=""
                            src="./../../assets/images/alert.svg" />
                          Enter a valid Phone Number
                        </mat-error>
                        
                        <mat-error class="error-message"
                        *ngIf="field.name === 'phoneNumber' &&
                                          !companyInfo.get('companyInformation.phoneNumber')?.hasError('pattern') &&
                                          companyInfo.get('companyInformation.phoneNumber')?.hasError('minlength')">
                          <img class="error-icon" loading="lazy" alt=""
                            src="./../../assets/images/alert.svg" />
                            Enter at least 5 digits
                        </mat-error>
                        
                        <mat-error class="error-message"
                        *ngIf="field.name === 'phoneNumber' &&
                                          !companyInfo.get('companyInformation.phoneNumber')?.hasError('pattern') &&
                                          companyInfo.get('companyInformation.phoneNumber')?.hasError('maxlength')">
                          <img class="error-icon" loading="lazy" alt=""
                            src="./../../assets/images/alert.svg" />
                            Limit Exceeded: Max 15 digits.
                        </mat-error>
                        
                        <mat-error class="error-message"
                        *ngIf="field.name === 'email' && companyInfo.get('companyInformation.email')?.hasError('pattern')">
                          <img class="error-icon"  loading="lazy" alt=""
                            src="./../../assets/images/alert.svg" />
                          Enter a valid Email
                        </mat-error>
                       
                        <mat-error class="error-message"
                          *ngIf="field.name === 'name' && companyInfo.get('companyInformation.name')?.hasError('maxlength')">
                          <img class="error-icon"  loading="lazy" alt=""
                            src="./../../assets/images/alert.svg" />
                         Limit Exceeded : Max 150 characters
                        </mat-error>
  
                        <mat-error class="error-message"
                          *ngIf="field.name === 'brandName' && companyInfo.get('companyInformation.brandName')?.hasError('maxlength')">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                        Limit Exceeded : Max 150 characters
                        </mat-error> 
                      <mat-error class="error-message"
                          *ngIf="field.name === 'employeeCount' && companyInfo.get('companyInformation.employeeCount')?.hasError('maxlength')">
                          <img class="error-icon"  loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                        Limit Exceeded : Max 10 digits
                        </mat-error>
                        <mat-error class="error-message"
                         *ngIf="field.name === 'url'">
                          <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                          <span *ngIf="companyInfo.get('companyInformation.url')?.hasError('maxlength')" >
                            Limit Exceeded: Max 150 characters
                          </span>
                          <span *ngIf="companyInfo.get('companyInformation.url')?.hasError('pattern') && 
                                      !companyInfo.get('companyInformation.url')?.hasError('maxlength')">
                            Url start with "http", "https" or "www"
                          </span>
                        </mat-error>
                     </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.name === 'continent'">
                      <input matInput (input)="onInputChangeContinent()" formControlName="continent"
                        placeholder="Select Continent" (blur)="validateInputContinent()"
                        [matAutocomplete]="continentAuto" [formControl]="continentControl">
                      <mat-autocomplete #continentAuto="matAutocomplete"
                        (optionSelected)="onOptionSelected($event , 'continent')">
                        <mat-option *ngFor="let continent of filteredContinents" [value]="continent.continentName">
                          {{ continent?.continentName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.name === 'country'">
                      <input matInput (input)="onInputChangeCountry()" formControlName="country"
                        placeholder="Select Country" (blur)="validateInputCountry()" [matAutocomplete]="countryAuto"
                        [formControl]="countryControl">
                      <mat-autocomplete #countryAuto="matAutocomplete"
                        (optionSelected)="onOptionSelected($event , 'country')">
                        <mat-option *ngFor="let country of filteredCountries" [value]="country.countryName">
                          {{ country?.countryName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.name === 'state'">
                      <input matInput (input)="onInputChangeState()" formControlName="state" placeholder="Select State"
                        (blur)="validateInputState()" [matAutocomplete]="stateAuto" [formControl]="stateControl">
                      <mat-autocomplete #stateAuto="matAutocomplete"
                        (optionSelected)="onOptionSelected($event , 'state')">
                        <mat-option *ngFor="let state of filteredStates" [value]="state.stateName">
                          {{ state?.stateName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.name === 'city'">

                      <input matInput (input)="onInputChangeCity()" formControlName="city" placeholder="Select City"
                        (blur)="validateInputCity()" [matAutocomplete]="cityAuto" [formControl]="cityControl">
                      <mat-autocomplete #cityAuto="matAutocomplete"
                        (optionSelected)="onOptionSelected($event , 'city')">
                        <mat-option *ngFor="let city of filteredCities" [value]="city.cityName">
                          {{ city?.cityName }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div #scrollContaine *ngIf="showCertificateFields">
    <div class="right">
      <div class="information2">
        <span class="div-header">Certificates</span>
        <form [formGroup]="companyInfo">
          <div formGroupName="companyInformation">
            <div class="row" *ngFor="let field of certificateFields" style="margin-top: 5px;">
              <div class="headings col-md-3">
                <div class="label error-cr-copy-popUp">
                  <p class="text">{{ field.label }} <span *ngIf="field.label === 'CR Copy'" class="text-danger">*</span>
                  </p>
                  <div *ngIf="field.label === 'CR Copy' && isFieldInvalid('crcopy')" class="error-message">
                    <img class="error-icon"  loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                    CR Copy is required.
                  </div>
                </div>
              </div>
              <div class="col-md-9" (dragover)="onDragOver($event)" (drop)="onDrop($event, field.name)">
                <div class="card" [ngClass]="{'invalid-field': isFieldInvalid(field.name)}"
                  style="margin-bottom: 15px;">

                  <input *ngIf="field.name !== 'otherFiles'" class="d-none" type="file" id="{{ field.name }}" accept="*"
                    (change)="selectFile($event, field.name)" />
                  <input *ngIf="field.name === 'otherFiles'" #otherFilesInput class="d-none" type="file"
                    id="{{ field.name }}" accept=".png,.jpg,.jpeg,.svg,.pdf" (change)="selectFiles($event, field.name)"
                    multiple />

                  <label
                    *ngIf="!companyInfo.get('companyInformation.' + field.name)?.value || (field.name === 'otherFiles' && !companyInfo.get('companyInformation.' + field.name)?.value.length)"
                    class="d-flex justify-content-center text" for="{{ field.name }}" mat-raised-button>
                    <img alt="" src="./../../assets/images/photo-add.svg" height="20px" width="20px" />
                    Drag files here to upload (or) Select Files
                  </label>

                  <div *ngIf="
                    field.name !== 'otherFiles' &&
                    companyInfo.get('companyInformation.' + field.name)?.value
                  " class="d-flex align-items-center">
                    <div class="input-group">
                      <div class="d-flex align-items-center">
                        <a
                        [href]="getFileURL(companyInfo.get('companyInformation.' + field.name)?.value)"
                        target="_blank"
                        class=" border-0 text-decoration-none"
                        style=" cursor: pointer;">
                        {{ getFileName(companyInfo.get('companyInformation.' + field.name)?.value) }}
                      </a>
                        <button class="btn border-0" mat-icon-button (click)="clearFile(field.name)"
                          style="margin-left: -10px;">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="field.name === 'otherFiles'">
                    <div class="d-flex flex-column">
                      <div class="file-list" style="max-height: 100px; overflow-y: auto;">
                        <div *ngFor="
                          let file of
                            companyInfo.get('companyInformation.' + field.name)
                              ?.value;
                          let i = index
                        " class="d-flex align-items-center">
                          <div class="input-group">
                            <div class="d-flex align-items-center">
                                <a
                                [href]="getFileURL(file)"
                                target="_blank"
                                class=" abcd border-0 text-decoration-none"
                                style=" cursor: pointer;">
                                {{ getFileName(file) }}
                              </a>
                              <button class="btn border-0" mat-icon-button (click)="clearFile(field.name, i)"
                                style="margin-left: -10px;">
                                <mat-icon>close</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="add-img" *ngIf="
                        companyInfo.get('companyInformation.' + field.name)
                          ?.value?.length
                      ">
                        <img class="edit-profile mx-1" (click)="triggerOtherFilesInputClick()"
                          src="../../assets/images/add.svg" alt="Edit Profile" />
                        <span class="text1">Add</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="informations">
        <span class="div-header2">Subscription Plan</span>
        <div class="subscription-info">
          <img *ngIf="subscriptionImage" [src]="subscriptionImage" alt="{{ subscriptionName }}"
            class="subscription-image">
          <span class="subscription-name"
            [ngStyle]="{'margin-top.px': (subscriptionName === 'Free Plan') ? '10' : null, 'margin-left.px': (subscriptionName === 'Free Plan') ? '18' : null}">{{
            subscriptionName }}</span>
        </div>
      </div>
      <div class="informations">
        <span class="div-header2">Status</span>
        <ul class="key-value-list">
          <li>
            <span class="key">{{ status }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showBothFields" class="info">
  <div class="left">
    <div class="information">
      <span class="div-header">Information</span>
      <form [formGroup]="companyInfo">
        <div formGroupName="companyInformation">
          <div class="row" *ngFor="let field of informationFields" style="margin-bottom: -15px;">
            <div class="headings col-md-3">
              <div class="label">
                <p class="text">{{ field.label }}<span *ngIf="!['employeeCount','url','continent', 'address','zipCode', 'country', 'state', 'city'].includes(field.name)" class="text-danger">*</span></p>
              </div>
            </div>
            <div class="col-md-9">
              <div *ngIf="field.name === 'logo'">
                <div *ngIf="companyInfo.get('companyInformation.logo')?.value" class="row"
                  style="margin-top: 3px; margin-bottom: 23px;">
                  <div class="col-md-12">
                    <img [src]="companyInfo.get('companyInformation.logo')?.value" alt="Logo" width="100">
                    &nbsp;&nbsp;
                    <button type="button" class="mwe-button mwe-button--primary ps-3 pe-3"
                      (click)="triggerLogoInputClick()">Update Logo</button>
                    <input type="file" #logoInput (change)="selectFile($event, 'logo')" style="display: none;">
                  </div>
                </div>
                <div *ngIf="!companyInfo.get('companyInformation.logo')?.value" class="row"
                  style="margin-top: 3px; margin-bottom: 23px;">
                  <div class="col-md-12">
                    <button type="button" class="mwe-button mwe-button--primary ps-3 pe-3"
                      (click)="triggerLogoInputClick()">Add Logo</button>
                    <input type="file" #logoInput (change)="selectFile($event, 'logo')" style="display: none;">
                  </div>
                </div>
              </div>

              <mat-form-field appearance="outline" style="margin-bottom: 15px; display: block;" class="w-100 custome-error-message"
                *ngIf="field.name !== 'continent' && field.name !== 'country' && field.name !== 'state' && field.name !== 'city' && field.name !== 'logo'">
                <span *ngIf="field.name === 'phoneNumber'" matPrefix>&nbsp;&nbsp;{{
                  companyInfo.get('companyInformation.phoneCode')?.value }}&nbsp;</span>
                <input matInput [formControlName]="field.name"
                  (keypress)="field.name === 'year'  || field.name === 'employeeCount' ? numberOnly($event) : null"
                  [placeholder]="field.name === 'year' ? 'yyyy' : 'Enter ' + field.label" [readonly]="field.name === 'email'"
                  [pattern]="( field.name === 'year' || field.name === 'zipCode'|| field.name === 'employeeCount') ? '^[0-9]*$' : ''"
                  [minlength]="(field.name === 'year') ? 4 : (field.name === 'phoneNumber') ? 5  : null"
                  [maxlength]="(field.name === 'year') ? 4 : (field.name === 'phoneNumber') ? 20  : null">

                <mat-error class="error-message" *ngIf="companyInfo.get('companyInformation.' + field.name)?.hasError('required')">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  {{ field.label }} is required
                </mat-error>
   
                <mat-error class="error-message" *ngIf="field.name === 'userName' && companyInfo.get('companyInformation.userName')?.hasError('maxlength');">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                Limit Exceeded : Max 50 characters
                </mat-error>

                <mat-error class="error-message"
                  *ngIf="field.name === 'name' && companyInfo.get('companyInformation.name')?.hasError('maxlength');">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Limit Exceeded : Max 150 characters
                </mat-error>
                
                <mat-error class="error-message"
                  *ngIf="field.name === 'brandName' && companyInfo.get('companyInformation.brandName')?.hasError('maxlength');">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Limit Exceeded : Max 150 characters
                </mat-error>
                
                <mat-error class="error-message"
                  *ngIf="field.name === 'employeeCount' && companyInfo.get('companyInformation.employeeCount')?.hasError('maxlength')">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Limit Exceeded : Max 10 digits
                </mat-error>
                
                <mat-error class="error-message" *ngIf="field.name === 'phoneNumber' &&
                                                          !companyInfo.get('companyInformation.phoneNumber')?.hasError('pattern') &&
                                                          companyInfo.get('companyInformation.phoneNumber')?.hasError('minlength')">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Enter at least 5 digits
                </mat-error>
                
                <mat-error class="error-message" *ngIf="field.name === 'phoneNumber' &&
                                                          !companyInfo.get('companyInformation.phoneNumber')?.hasError('pattern') &&
                                                          companyInfo.get('companyInformation.phoneNumber')?.hasError('maxlength')">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Limit Exceeded: Max 15 digits.
                </mat-error>
                              
                <mat-error class="error-message"
                  *ngIf="companyInfo.get('companyInformation.' + field.name)?.hasError('pattern') &&
                                        !companyInfo.get('companyInformation.' + field.name)?.hasError('maxlength') &&
                                        !companyInfo.get('companyInformation.' + field.name)?.hasError('required')">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  Enter a valid {{ field.label }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 15px;"
                *ngIf="field.name === 'continent'">
                <input matInput (input)="onInputChangeContinent()" formControlName="continent"
                  placeholder="Select Continent" (blur)="validateInputContinent()" [matAutocomplete]="continentAuto"
                  [formControl]="continentControl">
                <mat-autocomplete #continentAuto="matAutocomplete"
                  (optionSelected)="onOptionSelected($event , 'continent')">
                  <mat-option *ngFor="let continent of filteredContinents" [value]="continent.continentName">
                    {{ continent?.continentName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 15px;"
                *ngIf="field.name === 'country'">
                <input matInput (input)="onInputChangeCountry()" formControlName="country" placeholder="Select Country"
                  (blur)="validateInputCountry()" [matAutocomplete]="countryAuto" [formControl]="countryControl">
                <mat-autocomplete #countryAuto="matAutocomplete"
                  (optionSelected)="onOptionSelected($event , 'country')">
                  <mat-option *ngFor="let country of filteredCountries" [value]="country.countryName">
                    {{ country?.countryName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 15px;"
                *ngIf="field.name === 'state'">
                <input matInput (input)="onInputChangeState()" formControlName="state" placeholder="Select State"
                  (blur)="validateInputState()" [matAutocomplete]="stateAuto" [formControl]="stateControl">
                <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onOptionSelected($event , 'state')">
                  <mat-option *ngFor="let state of filteredStates" [value]="state.stateName">
                    {{ state?.stateName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 15px;"
                *ngIf="field.name === 'city'">
                <input matInput (input)="onInputChangeCity()" formControlName="city" placeholder="Select City"
                  (blur)="validateInputCity()" [matAutocomplete]="cityAuto" [formControl]="cityControl">
                <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onOptionSelected($event , 'city')">
                  <mat-option *ngFor="let city of filteredCities" [value]="city.cityName">
                    {{ city?.cityName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="right">
    <div class="information">
      <span class="div-header">Certificates</span>
      <form [formGroup]="companyInfo">
        <div formGroupName="companyInformation">
          <div class="row" *ngFor="let field of certificateFields" style="margin-bottom: -5px;">
            <div class="headings col-md-3">
              <div class="label error-cr-copy error-cr-copy-tab">
                <p class="text">{{ field.label }}
                  <span *ngIf="field.label === 'CR Copy'" class="text-danger">*</span>
                </p>
                <div *ngIf="field.label === 'CR Copy' && companyInfo.get('companyInformation.crcopy')?.hasError('required')" class="error-message">
                  <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                  CR Copy is required
                </div>
              </div>
            </div>
            <div class="col-md-9" (dragover)="onDragOver($event)" (drop)="onDrop($event, field.name)">
              <div class="card" [ngClass]="{'invalid-field': isFieldInvalid(field.name)}"
                style="margin-bottom: 25px; display: block;">
                <input *ngIf="field.name !== 'otherFiles'" class="d-none" type="file" id="{{ field.name }}" accept="*"
                  (change)="selectFile($event, field.name)" />
                <input *ngIf="field.name === 'otherFiles'" #otherFilesInput class="d-none" type="file"
                  id="{{ field.name }}" accept=".png,.jpg,.jpeg,.svg,.pdf" (change)="selectFiles($event, field.name)"
                  multiple />
                <label
                  *ngIf="!companyInfo.get('companyInformation.' + field.name)?.value || (field.name === 'otherFiles' && !companyInfo.get('companyInformation.' + field.name)?.value.length)"
                  class="d-flex justify-content-center text" for="{{ field.name }}" mat-raised-button>
                  <img alt="" src="./../../assets/images/photo-add.svg" height="20px" width="20px" />
                  Drag files here to upload (or) Select Files
                </label>
                <div *ngIf="field.name !== 'otherFiles' && companyInfo.get('companyInformation.' + field.name)?.value"
                  class="d-flex align-items-center">
                  <div class="input-group">
                    <div class="d-flex align-items-center">
                      <a
                        [href]="getFileURL(companyInfo.get('companyInformation.' + field.name)?.value)"
                        target="_blank"
                        class=" border-0 text-decoration-none"
                        style=" cursor: pointer;">
                        {{ getFileName(companyInfo.get('companyInformation.' + field.name)?.value) }}
                      </a>
                      <button class="btn border-0" mat-icon-button (click)="clearFile(field.name)"
                        style="margin-left: -10px;">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="field.name === 'otherFiles'">
                  <div class="d-flex flex-column">
                    <div class="file-list" style="max-height: 100px; overflow-y: auto;">
                      <div *ngFor="let file of companyInfo.get('companyInformation.' + field.name)?.value; let i = index"
                        class="d-flex align-items-center">
                        <div class="input-group">
                          <div class="d-flex align-items-center">
                            <a
                              [href]="getFileURL(file)"
                              target="_blank"
                              class=" abcd border-0 text-decoration-none"
                              style=" cursor: pointer;">
                              {{ getFileName(file) }}
                            </a>
                            <button class="btn border-0" mat-icon-button (click)="clearFile(field.name, i)"
                              style="margin-left: -10px;">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="add-img" *ngIf="companyInfo.get('companyInformation.' + field.name)?.value?.length">
                      <img class="edit-profile mx-1" (click)="triggerOtherFilesInputClick()"
                        src="../../assets/images/add.svg" alt="Edit Profile" />
                      <span class="text1">Add</span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="informations">
      <span class="div-header2">Subscription Plan</span>
      <div class="subscription-info">
        <img *ngIf="subscriptionImage" [src]="subscriptionImage" alt="{{ subscriptionName }}"
          class="subscription-image">
        <span class="subscription-name"
          [ngStyle]="{'margin-top.px': (subscriptionName === 'Free Plan') ? '10' : null, 'margin-left.px': (subscriptionName === 'Free Plan') ? '18' : null}">{{
          subscriptionName }}</span>
      </div>
    </div>

    <div class="informations">
      <span class="div-header2">Status</span>
      <ul class="key-value-list">
        <li>
          <span class="key">{{ status }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>